<template>
  <div>
    <v-alert v-show="alert" color="secondary" icon="warning" value="true" outline>
      Attention, le ciblage comportemental n'est pas accessibles pour ce niveau de licence. Vous ne pourrez pas sauvegarder.
    </v-alert>
    <v-container grid-list-lg>
      <v-layout row wrap>
        <!-- SITE -->
        <v-flex xs12 md6>
          <wz-select-one-site></wz-select-one-site>
        </v-flex>
        <!-- AGENT -->
        <v-flex xs12 md6>
          <wz-select-one-agent :agent.sync="agent"></wz-select-one-agent>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Chargement -->
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    <div v-else-if="!loading && filters.length" class="mb-5">
      <!-- Import des filtres d'un autre agent -->
      <v-btn
        flat
        @click="openDialogImport()"
        color="primary"
        :block="$vuetify.breakpoint.smAndDown"
      >
        {{ $t('importFiltersFromAgent') }}
        <v-icon right>get_app</v-icon>
      </v-btn>
      <v-card>
        <v-alert v-show="activeFilters == 0" color="secondary" icon="warning" value="true" outline>
          {{  $t('warnNoFilter')  }} <code>{{ agent.USR_FIRST_NAME }} {{ agent.USR_LAST_NAME }}</code>
          {{  $t('warnOnSite')  }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
        </v-alert>
        <v-list dense two-line>
          <v-subheader>{{ $tc('activeFilters', activeFilters, { count: activeFilters }) + ' ' + $t('outOf') + ' ' + filters.length }}</v-subheader>
          <v-list-tile v-for="filtre in filters" :key="filtre.id" avatar @click="showFilter(filtre.id)">
            
              <v-list-tile-action>
                <v-tooltip right>
                  <v-btn icon="icon"
                    slot="activator"
                    @mouseover.native="overMenu = true"
                    @mouseleave.native="overMenu = false"
                    @click="openDialogActivate(filtre.id, filtre.active, filtre.name)"
                  >
                    <v-icon medium class="primary--text" v-if="filtre.active == 1">play_circle_filled</v-icon>
                    <v-icon medium class="grey--text text--lighten-1" v-else>pause_circle_filled</v-icon>
                  </v-btn>
                  <span v-if="filtre.active == 1">{{ $t('disable') | cap }} scenario</span>
                  <span v-else>{{ $t('enable') | cap }} scenario</span>
                </v-tooltip>
              </v-list-tile-action>       
            <v-list-tile-content>
              <v-list-tile-title>{{ filtre.name }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ filtre.comment }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <span class="grey--text text--darken-2" v-if="filtre.multiUser > 1">{{ $t('shared') }}</span>
                <span class="grey--text text--darken-2" v-else>{{ $t('onlyMe') }}</span> —
                {{ $t('triggered') + ' ' + $tc('times', filtre.called, { count: filtre.called }) }} /
                {{ $tc('responses', filtre.success, { count: filtre.success }) }}
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-menu bottom left>
                <v-btn icon="icon" slot="activator" @mouseover.native="overMenu = true" @mouseleave.native="overMenu = false">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list dense>
                  <v-list-tile @click="openDialogActivate(filtre.id, filtre.active, filtre.name)">
                    <v-list-tile-action>
                      <v-icon v-if="filtre.active == 1">pause_circle_filled</v-icon>
                      <v-icon v-else>play_circle_filled</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title v-if="filtre.active == 1">{{ $t('disable') | cap }} scenario</v-list-tile-title>
                      <v-list-tile-title v-else>{{ $t('enable') | cap }} scenario</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="showFilter(filtre.id)">
                    <v-list-tile-action>
                      <v-icon>edit</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ $t('edit') | cap }} scenario</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="openDialogCopy(filtre.id, filtre.name)">
                    <v-list-tile-action>
                      <v-icon>content_copy</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ $t('duplicate') | cap }} scenario</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="openDialogDelete(filtre.id, filtre.name,agent.USR_ID)">
                    <v-list-tile-action>
                      <v-icon>delete</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ $t('delete') | cap }} scenario</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile v-if="filtre.multiUser < 2" @click="openDialogShare(filtre.id, filtre.name)">
                    <v-list-tile-action>
                      <v-icon>share</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ $t('share') | cap }} scenario</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-list-tile-action>

          </v-list-tile>
        </v-list>
      </v-card>
    </div>
    <!-- Filtres -->
    <!-- Aucun résultat -->
    <v-card v-else>
      <v-container fluid grid-list-lg>
        <v-layout row>
          <v-flex xs3>
            <v-img
              src="https://www.gstatic.com/mobilesdk/170418_mobilesdk/zeroState/2x/performance.png"
              height="125px"
              contain
            ></v-img>
          </v-flex>
          <v-flex xs7>
            <div>
              <div class="headline">{{ $tc('filtres', 0) | cap }}</div>
              <div>
                {{ $tc('filtres', 0) + ' ' + $t('forTheAgent') | cap}} <code>{{ agent.USR_FIRST_NAME }} {{ agent.USR_LAST_NAME }}</code>
                {{ $t('forTheSite') }} <code>{{ $store.state._Sites.siteSelected.LIC_URL }}</code>
              </div>
              <!-- Import des filtres d'un autre agent -->
              <v-btn
                flat
                @click="openDialogImport()"
                color="primary"
                :block="$vuetify.breakpoint.smAndDown"
              >
                {{ $t('importFiltersFromAgent') }}
                <v-icon right>get_app</v-icon>
              </v-btn>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-fab-transition>
      <v-btn
        v-if="!alert"
        dark
        color="secondary"
        fab
        fixed
        bottom
        right
        @click.native.stop="openDialogCreate">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <!-- DIALOGUE -->
    <v-dialog v-model="showDialogCreate" persistent max-width="290">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('addScenario') }}</v-card-title>
        <v-card-text>
          <v-text-field
            autofocus
            required
            :label="$t('scenarioName')" 
            v-model="newFilterDialog.name"
            counter 
            max="32" 
            v-validate="'max:32'" 
            data-vv-name="newSiteName"
            @keyup.native.enter="submitDialogCreate" >
          </v-text-field>
          <v-text-field
            autofocus
            :label="$t('scenarioComment')" 
            v-model="newFilterDialog.comment"
            counter 
            max="255" 
            v-validate="'max:255'" 
            data-vv-name="newSiteUrl"
            @keyup.native.enter="submitDialogCreate" >
          </v-text-field>
          <v-select
            :label="$t('scenarioActivate')"
            v-model="newFilterDialog.activated"
            v-bind:items="yesno">
          </v-select>
          <v-select
            :label="$t('scenarioAttributed') "
            v-model="newFilterDialog.multiUser"
            v-bind:items="multiUser">
          </v-select>
           <v-select
            :label="$t('scenarioPriority')"
            v-model="newFilterDialog.level"
            v-bind:items="priotit">
          </v-select>
          <v-select
            :label="$t('behaviour')"
            v-model="newFilterDialog.behaviour"
            v-bind:items="behaviour">
          </v-select>
         <small>*{{  $t('triggersNextStep')  }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="showDialogCreate = false">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" flat @click.native="submitDialogCreate">{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialogue d'import de filtres -->
    <v-dialog v-model="dialogImport" persistent max-width="500">
      <v-card>
        <v-card-title class="primary white--text">{{ $t('importFiltersFromAgent') }}</v-card-title>
        <v-card-text>
          <wz-select-one-agent
            :agent.sync="agentSource"
            :hint="$t('agentSourceInfos')"
          ></wz-select-one-agent>
          <v-icon>arrow_downward</v-icon>
          <wz-select-one-agent
            :agent.sync="agentDest"
            :hint="$t('agentDestInfos')"
          ></wz-select-one-agent>
          <v-alert
            icon="warning"
            color="secondary"
            :value="true"
            outline
          >{{ $t('infosImportFiltersFromAgent') }}</v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            flat
            :loading="loadingImport"
            @click="dialogImport = false"
          >{{ $t('cancel') }}</v-btn>
          <v-btn
            v-if="agent"
            color="primary"
            :loading="loadingImport"
            @click="submitDialogImport"
          >{{ $t('submit') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog progress bar installation -->
    <wz-dialog-progress
      @fermeDialogProgress="fermeDialogProgress"
      :dialogProgress="dialogProgress"
      :etape=14
    >
    </wz-dialog-progress>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      alert: false,
       /**
       * indique si une requête ajax en cours
       * @type {Boolean}
       */
      loading: false,
       /**
        * affiche/cache la fenetre de dialog de création
        * @type {Boolean}
        */
      showDialogCreate: false,
       /**
      * nouvelle bibliothèque à créer
      * @type {Object}
      */
      newFilterDialog: {activated: '1', allAgents: '0', multiUser: 'me'},
      /**
       * indique si la souris est au-dessus du menu de la liste
       * @type {Boolean}
       */
      overMenu: false,
      /**
       * Liste des filtres affiché dans le formulaire
       * @type {Array}
       */
      filters: [],
      siteKey: '',
      agent: {},
      resAjx: null,
      priotit: [
        { text: '1', value: '1' },
        { text: '2', value: '2' },
        { text: '3', value: '3' },
        { text: '4', value: '4' },
        { text: '5', value: '5' },
        { text: '6', value: '6' },
        { text: '7', value: '7' },
        { text: '8', value: '8' },
        { text: '9', value: '9' },
        { text: '10', value: '10' }
      ],
      yesno: [
        { text: this.$t('yes'), value: '1' },
        { text: this.$t('no'), value: '0' }
      ],
      multiUser: [
        { text: this.$t('onlyMe'), value: 'me' },
        { text: this.$t('allAgents'), value: 'all' }
      ],
      behaviour: [
        { text: this.$t('sendInvit'), value: 'invitation' },
        { text: this.$t('sendPush'), value: 'push', disabled: this.$store.state._User.entLevel !== '7' }
      ],
      /**
       * Partie Import de filtres
       */
      dialogImport: false,
      agentSource: {},
      agentDest: {},
      loadingImport: false,
      dialogProgress: false
    }
  },
  computed: {
    ...mapGetters('_User', [ 'user' ]),
    activeFilters () {
      return _.filter(this.filters, f => f.active === '1').length
    }
  },
  mounted () {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress()
    }
    if (this.$store.state._User.entLevel === '5') {
      this.alert = true
    }
  },
  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'target_filters'
    }
    /* eslint-enable */
  },
  methods: {
    init () {
      this.loading = true
      this.resAjx = null
      this.filters = []
      let dataToPost = new window.FormData()
      dataToPost.append('forceSite', this.$store.state._Sites.siteSelected.LIC_ID)
      dataToPost.append('forceAgent', this.agent.USR_ID)
      this.axios.post('get/filters.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.resAjx = response.data
      })
      .then(_ => {
        this.loading = false
        this.initFilters()
      })
      .catch()
    },
    openDialogActivate (_id, _activate, _name) {
      let _activation = 0
      let _justdoit = false
      console.log('ac' + _justdoit)
      if (_activate === '1') {
        _justdoit = confirm(this.$t('scenarioSuspend') + ' ' + _name + ' ' + this.$t('forAllAgents'))
        _activation = 0
      } else if (_activate === '0') {
        _justdoit = confirm(this.$t('scenarioActivate') + ' ' + _name + ' ' + this.$t('forAllAgents'))
        _activation = 1
      }
      if (_justdoit) {
        console.log('dc' + _justdoit)
        // Données modifiées et à renvoyer
        let dataToPost = new window.FormData()
        dataToPost.append('filId', _id)
        dataToPost.append('active', _activation)
        this.axios.post('put/activfilter.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure'), context: 'error' })
        })
        .then(_ => {
          this.init()
        })
      }
    },
    openDialogCopy (_id, _name) {
      if (confirm(this.$t('scenarioDuplic') + ' ' + _name)) {
        // Données modifiées et à renvoyer
        let dataToPost = new window.FormData()
        dataToPost.append('filId', _id)
        this.axios.post('post/duplicfilter.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('duplicateSuccess'), context: 'success' })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('duplicateFailure'), context: 'error' })
        })
        .then(_ => {
          this.init()
        })
      }
    },
    openDialogDelete (_id, _name, _agent) {
      if (confirm(this.$t('scenarioSuppr') + ' ' + _name + ' ' + this.$t('forCurrentAgents'))) {
        // Données modifiées et à renvoyer
        let dataToPost = new window.FormData()
        dataToPost.append('filId', _id)
        dataToPost.append('agent', _agent)
        this.axios.post('delete/filter.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteSuccess'), context: 'success' })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('deleteFailure'), context: 'error' })
        })
        .then(_ => {
          this.init()
        })
      }
    },
    openDialogShare (_id, _name) {
      if (confirm(this.$t('scenarioShare') + ' ' + _name + ' ' + this.$t('withAll'))) {
        // Données modifiées et à renvoyer
        let dataToPost = new window.FormData()
        dataToPost.append('filId', _id)
        this.axios.post('post/sharefilter.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifSuccess'), context: 'success' })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('error'), context: 'error' })
        })
        .then(_ => {
          this.init()
        })
      }
    },
    initFilters () {
      for (var n in this.resAjx) {
        var _behav = ''
        if (this.resAjx[n].push === '1') {
          _behav = 'push'
        } else if (this.resAjx[n].invitation === '1') {
          _behav = 'invitation'
        }
        // console.log(this.resAjx[n].multiUser)
        this.filters.push({ id: this.resAjx[n].id,
          name: this.resAjx[n].name,
          user_id: this.resAjx[n].user_id,
          lickey: this.resAjx[n].lickey,
          comment: this.resAjx[n].comment,
          appear: this.resAjx[n].appear,
          notification: this.resAjx[n].notification,
          push: this.resAjx[n].push,
          pushId: this.resAjx[n].pushId,
          invitation: this.resAjx[n].invitation,
          invitationMsg: this.resAjx[n].invitationMsg,
          active: this.resAjx[n].active,
          usage: this.resAjx[n].usage,
          responseRate: this.resAjx[n].responseRate,
          level: this.resAjx[n].level,
          family: this.resAjx[n].family,
          called: this.resAjx[n].called,
          success: this.resAjx[n].success,
          creationTs: this.resAjx[n].creationTs,
          multiUser: this.resAjx[n].multiUser,
          constraints: this.resAjx[n].constraints,
          behaviour: _behav
        })
        this.siteKey = this.resAjx[n].lickey
      }
    },
    /**
     * ouvre la fenêtre de dialogue et initialise un  nouveau filtre à créer
     */
    openDialogCreate () {
      this.showDialogCreate = true
    },
    /**
     * valide la nouvelle bibliothèque à créer
     */
    submitDialogCreate () {
      this.showDialogCreate = false
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()
      dataToPost.append('agent_id', this.agent.USR_ID)
      dataToPost.append('newfilter', JSON.stringify(this.newFilterDialog))
      dataToPost.append('siteKey', this.$store.state._Sites.siteSelected.LIC_KEY)
      this.axios.post('post/newfilter.php', dataToPost, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationSuccess'), context: 'success' })
        this.showFilter(response.data.id)
      })
      .catch(_ => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationFailure'), context: 'error' })
      })
    },
    showFilter (_id) {
      // pour éviter de réaliser l'évenement si la souris est au-dessus du bouton de click
      if (!this.overMenu) {
        this.$router.push({ path: '/target/filters/' + _id })
      }
    },
    /**
     * Ouvre la dialog d'import de phrases
     */
    openDialogImport () {
      this.dialogImport = true
    },
    submitDialogImport () {
      if (this.agentSource.USR_ID === this.agentDest.USR_ID) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('error') + ' : ' + this.$t('sameAgents'),
          context: 'error'
        })
        return
      }
      let params = new window.FormData()
      params.append('src', this.agentSource.USR_ID)
      params.append('dest', this.agentDest.USR_ID)
      this.loadingImport = true
      this.axios.post('post/import_filters.php', params, {headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
      .then(res => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('importSuccess'),
          context: 'success'
        })
        this.init()
      })
      .catch(() => {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('importFailure'),
          context: 'error'
        })
      })
      .then(() => {
        this.loadingImport = false
        this.dialogImport = false
      })
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    'agent': function (val, oldVal) {
      this.init()
    },
    '$store.state._Sites.siteSelected': function (val, oldVal) {
      this.init()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/Filters.vue